import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext.jsx";
import { DonationProvider } from "./context/DonationContext.jsx";
import { DashboardProvider } from "./context/DashboardContext.jsx";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Pages
import Home from "./Pages/Home/Home.js";
import About from "./Pages/About.jsx";
import Founder from "./Pages/Founder/Founder.js";
import Philosophy from "./Pages/Philosophy/Philosophy.js";
import Mission from "./Pages/Mission/Mission.js";
import MoreAbout from "./Pages/MoreAbout/MoreAbout.js";
import NityaSeva from "./Pages/NityaSeva/NityaSeva.js";
import Arti from "./Pages/Temple/Arti/Arti.js";
import SaturdaySatsang from "./Pages/Temple/SaturdaySatsang/SaturdaySatsang.jsx";
import SundayFeast from "./Pages/Temple/SundayFeast/SundayFeast.jsx";
import LifeMembership from "./Pages/LifeTimeMembership/lifeMembershipPage.jsx";
import GauSeva from "./Pages/GauSeva/GauSeva.jsx";
import DiwaliDonation from "./Pages/DiwaliDonation/DiwaliDonation.jsx";
import GitaDaan from "./Pages/Gita-Daan/GitaDaan.jsx";
import FoodForLife from "./Pages/FoodForLife/FoodForLife";
import BhaktiVriksha from "./Pages/OurProgram/BhaktiVriskha/BhaktiVriksha.jsx";
import YouthSeminar from "./Pages/OurProgram/YouthSeminar/YouthSeminar.jsx";
import GitaForYou from "./Pages/OurProgram/GitaForYou/GitaForYou.jsx";
import GopalaFunSchool from "./Pages/OurProgram/GopalaForSchool/GopalaFunSchool.jsx";
import Counselling from "./Pages/OurProgram/Counselling/Counselling.jsx";
import SocialWork from "./Pages/OurProgram/Social Work/SocialWork.jsx";
import KirtanBookingPage from "./Pages/samskara/bookAKirtan/KirtanBookingPage.jsx";
import BookYagna from "./Pages/samskara/BookYagna/BookYagna.jsx";
import HowToReach from "./Pages/How to Reach/HowToReach.js";
import VaikuntaEkadashi from "./Pages/Vaikunta Ekadashi/VaikuntaEkadashi.jsx";
import MahaKumbhMela from "./Pages/MahaKumbhMela/MahaKumbhMela.js";
import DonationTemp from "./Pages/Donation-temp/DonationTemp.jsx";
import BhaktiShashtri from "./Pages/BhaktiShashtri/BhaktiShashtri.jsx";
import Gita4YouRegistration from "./Pages/Gita4You/Gita4YouRegistration.jsx";
import JointheFamily from "./Pages/JoinTheFamily/JointheFamily.jsx";
import CorporateProgram2 from "./Pages/CorporateProgram2/CorporateProgram2.jsx";
import RamNavami from "./Pages/Ramnavami.jsx";
import Gallery from "./Pages/Gallery/Gallery.jsx";
import StepsToBhakti from "./Pages/StepsToBhakti/stepstoBhakti.jsx";
import ChandanYatra from "./Pages/Chandan Yatra/ChandanYatra.jsx";
import Narasimha from "./Pages/Narasimha.jsx";
import RathYatra from "./Pages/RathYatra.jsx";
import RathYatraWalkathon from "./Pages/RathYatraWalkathon/RathYatraWalkathon.jsx";
import RathyatraRegister from "./Pages/RathyatraRegister.jsx";

import Janmashatmi from "./Pages/Janmashatmi.jsx";
import Kartik2025 from "./Pages/Kartik2025/Kartik2025.jsx";
import Radhastami2025 from "./Pages/Radhastami2025/Radhastami2025.jsx";
import ContactUs from "./Pages/ContactUs.jsx";
import SUPPORTUs from "./Pages/SUPPORT/Support.jsx";

import DasaraMahotsav2025 from "./Pages/DasaraMahotsav2025/DasaraMahotsav2025.jsx";
import Dashboard from "./Pages/Dashboard/Dashboard.jsx";
import UserProfile from "./Pages/UserProfile/UserProfile.jsx";
import EventsCMS from "./Pages/EventsCMS.jsx";
import AdminLogin from "./Pages/AdminLogin.jsx";
import CreateAdmin from "./Pages/CreateAdmin.jsx";

import AnniversaryIskcon from "./Pages/AnniversaryIskcon.jsx";
import HighLightFestival from "./Pages/HighLightFestival.jsx";
import NirjalaEkdasi from "./Pages/NirjalaEkdasi.jsx";
import NotFound from "./Pages/NotFound.jsx";
import CongregationPreaching from "./Pages/CongregationPreaching.jsx";

// Blogs
import SignificanceOfNarasimha from "./Pages/Blogs/SignificanceOfNarasimha/SignificanceOfNarasimha.jsx";
import NityaSevaBlog from "./Pages/Blogs/NityaSevaBlog/NityaSevaBlog.jsx";
import EkadashiImportance from "./Pages/EkadashiImportance.jsx";
import Blogs from "./Pages/Blogs/Blogs.jsx";
import SriKrishnaJanmashtami from "./Pages/Blogs/Janmashtami/Janmashtami.jsx";
import SriJagannathRathYatra from "./Pages/Blogs/SriJagannathRathYatra/SriJagannathRathYatra.jsx";
import EventDetails from "./Pages/Blogs/EventDetails.jsx";

// Components
import PoliciesUsage from "./Components/Footer/PoliciesUsage.jsx";
import PolicyDetail from "./Components/Footer/PolicyDetail.jsx";
import Fastival from "./Components/Fastival/Fastival.jsx";
import FormPage from "./Components/Fastival/FormPage.jsx";
import Courses from "./Components/Courses/Courses.jsx";
import QuickDonate from "./Components/NewQuickDon/QuickDonate.jsx";
import DonationTable from "./Components/DonationTable.jsx";
import WhatsAppScroll from "./Components/WhatsappScroll.jsx";
import BottomNavigation from "./Components/BottomNavigation.jsx";
import ThankYou from "./Components/ThankYou.jsx";

// Utils
import ProtectedRoutes from "./utils/ProtectedRoutes.jsx";
import RathFestRegistration from "./Pages/RathFestRegistartion.jsx";
import JanmashtmiSeva from "./Pages/JanmashtmiSeva.jsx";
import Pitrupaksha2026 from "./Pages/pitrupaksha2026.jsx";
import SrimadBhagavatam from "./Pages/srimadBhagavatm.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <DonationProvider>
      <AuthProvider>
        <DashboardProvider>
          <HelmetProvider>
            <Router>
              <div>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/founder" element={<Founder />} />
                  <Route path="/philosophy" element={<Philosophy />} />
                  <Route path="/mission" element={<Mission />} />
                  <Route path="/more-about-iskcon" element={<MoreAbout />} />
                  <Route path="/nitya-seva" element={<NityaSeva />} />
                  <Route path="/GauSeva" element={<GauSeva />} />
                  <Route path="/DiwaliDonation" element={<DiwaliDonation />} />
                  <Route path="/gita-daan" element={<GitaDaan />} />
                  <Route path="/MahaKumbhMela" element={<MahaKumbhMela />} />
                  <Route path="/Arti" element={<Arti />} />
                  <Route
                    path="/SaturdaySatsang"
                    element={<SaturdaySatsang />}
                  />
                  <Route path="/SundayFeast" element={<SundayFeast />} />
                  {/* <Route path="/yatra" element={<MathuraVrindavan />} /> */}
                  <Route path="/LifeMembership" element={<LifeMembership />} />
                  <Route path="/food-for-life" element={<FoodForLife />} />
                  <Route path="/BhaktiSastri" element={<BhaktiShashtri />} />
                  <Route path="/BhaktiVriksha" element={<BhaktiVriksha />} />
                  <Route path="/YouthSeminar" element={<YouthSeminar />} />
                  <Route path="/GitaForYou" element={<GitaForYou />} />
                  <Route
                    path="/GopalaFunSchool"
                    element={<GopalaFunSchool />}
                  />
                  <Route path="/Counselling" element={<Counselling />} />
                  <Route path="/SocialWork" element={<SocialWork />} />
                  <Route path="/thank-you" element={<ThankYou />} />
                  <Route path="/admin-login" element={<AdminLogin />} />
                  <Route element={<ProtectedRoutes />}>
                    <Route path="/iskconCMS" element={<EventsCMS />} />
                    <Route path="/create-admin" element={<CreateAdmin />} />
                  </Route>
                  <Route path="/event/:id" element={<EventDetails />} />
                  <Route
                    path="/CorporateProgrammes"
                    element={<CorporateProgram2 />}
                  />
                  <Route path="/policies-usage" element={<PoliciesUsage />} />
                  <Route
                    path="/policies-usage/:slug"
                    element={<PolicyDetail />}
                  />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route
                    path="/significance-of-narasimha"
                    element={<SignificanceOfNarasimha />}
                  />
                  <Route path="/nitya-seva-blog" element={<NityaSevaBlog />} />
                  <Route
                    path="/ekadashi-importance"
                    element={<EkadashiImportance />}
                  />
                  <Route
                    path="/sri-jagannath-rath-yatra"
                    element={<SriJagannathRathYatra />}
                  />
                  <Route
                    path="/sri-krishna-janmashtami"
                    element={<SriKrishnaJanmashtami />}
                  />
                  <Route
                    path="/kirtan-booking"
                    element={<KirtanBookingPage />}
                  />
                  <Route path="/yagna-booking" element={<BookYagna />} />
                  <Route path="/festival" element={<Fastival />} />
                  <Route path="/donation-form/:slug" element={<FormPage />} />
                  <Route path="/courses" element={<Courses />} />
                  <Route path="/HowToReach" element={<HowToReach />} />
                  <Route path="/QuickDonate" element={<QuickDonate />} />
                  <Route path="/DonationTable" element={<DonationTable />} />

                  <Route path="/donation-temp" element={<DonationTemp />} />
                  <Route path="/gita4You" element={<Gita4YouRegistration />} />
                  <Route path="/anniversary" element={<AnniversaryIskcon />} />
                  <Route
                    path="/VaikuntaEkadashi"
                    element={<VaikuntaEkadashi />}
                  />
                  <Route path="/JointheFamily" element={<JointheFamily />} />
                  <Route path="/ChandanYatra" element={<ChandanYatra />} />
                  <Route path="/NarasimhaChaturdashi" element={<Narasimha />} />
                  <Route path="/rathyatra" element={<RathYatra />} />
                  <Route
                    path="/rathyatrapuja"
                    element={<RathyatraRegister />}
                  />
                  <Route path="/rathfest" element={<RathFestRegistration />} />
                  <Route
                    path="/congregation-preaching"
                    element={<CongregationPreaching />}
                  />

                  <Route
                    path="/Walkathon2025"
                    element={<RathYatraWalkathon />}
                  />

                  <Route path="/janmashtami" element={<Janmashatmi />} />
                  <Route path="/Kartik" element={<Kartik2025 />} />
                  <Route path="/radhastami2025" element={<Radhastami2025 />} />

                  <Route
                    path="/dasaraAnnadan"
                    element={<DasaraMahotsav2025 />}
                  />
                  <Route path="/contactUs" element={<ContactUs />} />
                  <Route
                    path="/supportIskconVijayawada"
                    element={<SUPPORTUs />}
                  />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/UserProfile" element={<UserProfile />} />

                  <Route path="/StepsToBhakti" element={<StepsToBhakti />} />
                  <Route path="/HD-Photos-Videos" element={<Gallery />} />

                  <Route
                    path="/flowerFestival"
                    element={<HighLightFestival />}
                  />
                  <Route path="/RamNavami" element={<RamNavami />} />
                  <Route path="/ekadasi" element={<NirjalaEkdasi />} />
                  <Route path="/janmastmi-seva" element={<JanmashtmiSeva />} />
                  <Route
                    path="/pitruPakshaSeva2026"
                    element={<Pitrupaksha2026 />}
                  />

                  <Route
                    path="/srimadBhagavatm"
                    element={<SrimadBhagavatam />}
                  />

                  <Route path="*" element={<NotFound />} />
                </Routes>
                <WhatsAppScroll />
                <BottomNavigation />
              </div>
            </Router>
          </HelmetProvider>
        </DashboardProvider>
      </AuthProvider>
    </DonationProvider>
  </React.StrictMode>,
);
